[
  {
    "code": "GB-SCT-ABE",
    "name": "Aberdeen"
  },
  {
    "code": "GB-SCT-ABD",
    "name": "Aberdeenshire"
  },
  {
    "code": "GB-WLS-AGY",
    "name": "Anglesey"
  },
  {
    "code": "GB-SCT-ANS",
    "name": "Angus"
  },
  {
    "code": "GB-NIR-ANT",
    "name": "Antrim"
  },
  {
    "code": "GB-SCT-AGB",
    "name": "Argyll and Bute"
  },
  {
    "code": "GB-NIR-ARM",
    "name": "Armagh"
  },
  {
    "code": "GB-ENG-BDF",
    "name": "Bedfordshire"
  },
  {
    "code": "GB-NIR-BFS",
    "name": "Belfast"
  },
  {
    "code": "GB-ENG-BRC",
    "name": "Berkshire"
  },
  {
    "code": "GB-WLS-BGW",
    "name": "Blaenau Gwent"
  },
  {
    "code": "GB-WLS-BGE",
    "name": "Bridgend"
  },
  {
    "code": "GB-ENG-BST",
    "name": "Bristol"
  },
  {
    "code": "GB-ENG-BKM",
    "name": "Buckinghamshire"
  },
  {
    "code": "GB-WLS-CAY",
    "name": "Caerphilly"
  },
  {
    "code": "GB-ENG-CAM",
    "name": "Cambridgeshire"
  },
  {
    "code": "GB-WLS-CRF",
    "name": "Cardiff"
  },
  {
    "code": "GB-WLS-CMN",
    "name": "Carmarthenshire"
  },
  {
    "code": "GB-WLS-CGN",
    "name": "Ceredigion"
  },
  {
    "code": "GB-ENG-CHS",
    "name": "Cheshire"
  },
  {
    "code": "GB-SCT-CLK",
    "name": "Clackmannanshire"
  },
  {
    "code": "GB-WLS-CWY",
    "name": "Conwy"
  },
  {
    "code": "GB-ENG-CON",
    "name": "Cornwall"
  },
  {
    "code": "GB-ENG-CMA",
    "name": "Cumbria"
  },
  {
    "code": "GB-WLS-DEN",
    "name": "Denbighshire"
  },
  {
    "code": "GB-ENG-DBY",
    "name": "Derbyshire"
  },
  {
    "code": "GB-NIR-DRY",
    "name": "Derry"
  },
  {
    "code": "GB-ENG-DEV",
    "name": "Devon"
  },
  {
    "code": "GB-ENG-DOR",
    "name": "Dorset"
  },
  {
    "code": "GB-NIR-DOW",
    "name": "Down"
  },
  {
    "code": "GB-SCT-DGY",
    "name": "Dumfries and Galloway"
  },
  {
    "code": "GB-SCT-DND",
    "name": "Dundee"
  },
  {
    "code": "GB-ENG-DUR",
    "name": "Durham"
  },
  {
    "code": "GB-SCT-EAY",
    "name": "East Ayrshire"
  },
  {
    "code": "GB-SCT-EDU",
    "name": "East Dunbartonshire"
  },
  {
    "code": "GB-SCT-ELN",
    "name": "East Lothian"
  },
  {
    "code": "GB-ENG-ERY",
    "name": "East Riding of Yorkshire"
  },
  {
    "code": "GB-ENG-ESX",
    "name": "East Sussex"
  },
  {
    "code": "GB-SCT-EDH",
    "name": "Edinburgh"
  },
  {
    "code": "GB-SCT-ELS",
    "name": "Eilean Siar"
  },
  {
    "code": "GB-ENG-ESS",
    "name": "Essex"
  },
  {
    "code": "GB-SCT-FAL",
    "name": "Falkirk"
  },
  {
    "code": "GB-NIR-FER",
    "name": "Fermanagh"
  },
  {
    "code": "GB-SCT-FIF",
    "name": "Fife"
  },
  {
    "code": "GB-WLS-FLN",
    "name": "Flintshire"
  },
  {
    "code": "GB-SCT-GLG",
    "name": "Glasgow"
  },
  {
    "code": "GB-ENG-GLS",
    "name": "Gloucestershire"
  },
  {
    "code": "GB-WLS-GWN",
    "name": "Gwynedd"
  },
  {
    "code": "GB-ENG-HAL",
    "name": "Halton"
  },
  {
    "code": "GB-ENG-HAM",
    "name": "Hampshire"
  },
  {
    "code": "GB-ENG-HEF",
    "name": "Herefordshire"
  },
  {
    "code": "GB-ENG-HRT",
    "name": "Hertfordshire"
  },
  {
    "code": "GB-SCT-HLD",
    "name": "Highland"
  },
  {
    "code": "GB-ENG-IOW",
    "name": "Isle of Wight"
  },
  {
    "code": "GB-ENG-KEN",
    "name": "Kent"
  },
  {
    "code": "GB-ENG-LAN",
    "name": "Lancashire"
  },
  {
    "code": "GB-ENG-LEC",
    "name": "Leicestershire"
  },
  {
    "code": "GB-ENG-LIN",
    "name": "Lincolnshire"
  },
  {
    "code": "GB-ENG-LND",
    "name": "London"
  },
  {
    "code": "GB-ENG-MAN",
    "name": "Manchester"
  },
  {
    "code": "GB-ENG-KWL",
    "name": "Merseyside"
  },
  {
    "code": "GB-WLS-MTY",
    "name": "Merthyr Tydfil"
  },
  {
    "code": "GB-SCT-MLN",
    "name": "Midlothian"
  },
  {
    "code": "GB-WLS-MON",
    "name": "Monmouthshire"
  },
  {
    "code": "GB-SCT-MRY",
    "name": "Moray"
  },
  {
    "code": "GB-WLS-NTL",
    "name": "Neath Port Talbot"
  },
  {
    "code": "GB-WLS-NWP",
    "name": "Newport"
  },
  {
    "code": "GB-NIR-NYM",
    "name": "Newry and Mourne"
  },
  {
    "code": "GB-ENG-NFK",
    "name": "Norfolk"
  },
  {
    "code": "GB-SCT-NAY",
    "name": "North Ayrshire"
  },
  {
    "code": "GB-SCT-NLK",
    "name": "North Lanarkshire"
  },
  {
    "code": "GB-ENG-NYK",
    "name": "North Yorkshire"
  },
  {
    "code": "GB-ENG-NTH",
    "name": "Northamptonshire"
  },
  {
    "code": "GB-ENG-NBL",
    "name": "Northumberland"
  },
  {
    "code": "GB-ENG-NTT",
    "name": "Nottinghamshire"
  },
  {
    "code": "GB-NIR-OMH",
    "name": "Omagh"
  },
  {
    "code": "GB-SCT-ORK",
    "name": "Orkney Islands"
  },
  {
    "code": "GB-ENG-OXF",
    "name": "Oxfordshire"
  },
  {
    "code": "GB-WLS-PEM",
    "name": "Pembrokeshire"
  },
  {
    "code": "GB-SCT-PKN",
    "name": "Perthshire and Kinross"
  },
  {
    "code": "GB-WLS-POW",
    "name": "Powys"
  },
  {
    "code": "GB-SCT-RFW",
    "name": "Renfrewshire"
  },
  {
    "code": "GB-WLS-RCT",
    "name": "Rhondda, Cynon, Taff"
  },
  {
    "code": "GB-ENG-RUT",
    "name": "Rutland"
  },
  {
    "code": "GB-SCT-SCB",
    "name": "Scottish Borders"
  },
  {
    "code": "GB-SCT-ZET",
    "name": "Shetland Islands"
  },
  {
    "code": "GB-ENG-SHR",
    "name": "Shropshire"
  },
  {
    "code": "GB-ENG-SOM",
    "name": "Somerset"
  },
  {
    "code": "GB-SCT-SAY",
    "name": "South Ayrshire"
  },
  {
    "code": "GB-SCT-SLK",
    "name": "South Lanarkshire"
  },
  {
    "code": "GB-ENG-BNS",
    "name": "South Yorkshire"
  },
  {
    "code": "GB-ENG-STS",
    "name": "Staffordshire"
  },
  {
    "code": "GB-SCT-STG",
    "name": "Stirling"
  },
  {
    "code": "GB-ENG-STT",
    "name": "Stockton-on-Tees"
  },
  {
    "code": "GB-ENG-SFK",
    "name": "Suffolk"
  },
  {
    "code": "GB-ENG-SRY",
    "name": "Surrey"
  },
  {
    "code": "GB-WLS-SWA",
    "name": "Swansea"
  },
  {
    "code": "GB-WLS-TOF",
    "name": "Torfaen"
  },
  {
    "code": "GB-ENG-GAT",
    "name": "Tyne and Wear"
  },
  {
    "code": "GB-WLS-VGL",
    "name": "Vale of Glamorgan"
  },
  {
    "code": "GB-ENG-WAR",
    "name": "Warwickshire"
  },
  {
    "code": "GB-SCT-WDU",
    "name": "West Dunbartonshire"
  },
  {
    "code": "GB-SCT-WLN",
    "name": "West Lothian"
  },
  {
    "code": "GB-ENG-SAW",
    "name": "West Midlands"
  },
  {
    "code": "GB-ENG-WSX",
    "name": "West Sussex"
  },
  {
    "code": "GB-ENG-WKF",
    "name": "West Yorkshire"
  },
  {
    "code": "GB-ENG-WIL",
    "name": "Wiltshire"
  },
  {
    "code": "GB-ENG-WOR",
    "name": "Worcestershire"
  },
  {
    "code": "GB-WLS-WRX",
    "name": "Wrexham"
  }
]